// extracted by mini-css-extract-plugin
export var paginationContainer = "_61-0";